'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListJacketCover = require('./components/ListJacketCover.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListJacketCover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-jacket-cover/index.js
// module id = 919
// module chunks = 0